import React, {useState, useMemo, useEffect} from "react";
import Menu from "../../../../components/layout/menu/index";
import { getCriterionList, updateCriterion, softDeleteCriterionId, createCriterion } from "../../../../client/criterio/index";
import 'simplebar-react/dist/simplebar.min.css';
import ModalSuccess from "../../../../components/shared/modals/modalSuccess";
import ModalDelete from "../../../../components/shared/modals/modalDelete";
import DynamicTable from "../../../../components/tables/oc/provider/dynamicTable";
import InputField from "../../../../components/forms/inputField";
import SelectField from "../../../../components/forms/selectOption";
import { getCategoryList } from "../../../../client/criterio/index";
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

const CategoryTabs = ({ categories, activeTab, onTabChange }) => {
  return (
<SimpleBar >
      <div className="flex" style={{width: 'max-content'}}>
        {categories.map((category, index) => (
          <button
            key={category.id}
            className={`py-[17px] px-8 border-b-2 rounded-tl-xl rounded-tr-xl border-blue font-itcmedium text-lg ${
              activeTab === index
                ? 'bg-blue text-white'
                : 'text-blue bg-white'
            }`}
            onClick={() => onTabChange(index)}
          >
            {category.name}
          </button>
        ))}
      </div>
</SimpleBar>
  );
};

export default function CriteriaAdmin() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [isLoading, setIsLoading] = useState(true);
  const [criteria, setCriteria] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    weight: ''
  });
  const [editingId, setEditingId] = useState(null);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [activeCategoryTab, setActiveCategoryTab] = useState(0);

  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [modalSuccessText, setModalSuccessText] = useState('');

  const [showModalDelete, setShowModalDelete] = useState(false);
  const [selectedCriterionId, setSelectedCriterionId] = useState(null);
  const [categories, setCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const [showModalAlertWarning, setShowModalAlertWarning] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

useEffect(() => {
  const fetchData = async () => {
    try {
      const [criteriaResponse, categoriesResponse] = await Promise.all([
        getCriterionList(),
        getCategoryList()
      ]);

      const enhancedCriteria = criteriaResponse.data.map(category => ({
        ...category,
        criteria: category.criteria?.map(criterion => ({
          ...criterion,
          categoryId: category.id 
        }))
      }));

      setCriteria(enhancedCriteria);
      setCategories(categoriesResponse.data);
      
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  fetchData();
}, []);

  const isFormEmpty = useMemo(() => {
    return formData.name === '' && formData.description === '' && formData.weight === '';
  }, [formData]);

  const handleInputChange = (e) => {
    const {name, value} = e.target;
    
    if (name === 'weight') {
      const numericValue = parseInt(value, 10) || 0;
      if (numericValue > 100) return; 
      if (numericValue < 0) return;   
    }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setIsFormChanged(true);
  };

  const resetForm = () => {
    setFormData({
      name: '',
      description: '',
      weight: ''
    });
    setEditingId(null);
    setSelectedCategoryId(null);
    setIsFormChanged(false);
  };
  const scrollToTop = () => {
    window.scrollTo({ top: 130, behavior: "smooth" });
  };

  const handleEdit = (criterion) => {
    
    setFormData({
      name: criterion.name,
      description: criterion.description,
      weight: String(criterion.weight)
    });
    
    setEditingId(criterion.originalId || criterion.id);
    setSelectedCategoryId(criterion.categoryId);
    setIsFormChanged(false);
    scrollToTop();
    
  };

  const handleDelete = async (criterionId) => {
    setSelectedCriterionId(criterionId);
    setShowModalDelete(true);
  };

  const handleConfirmDelete = async () => {
    if (!selectedCriterionId) return;
    
    try {
      await softDeleteCriterionId(selectedCriterionId);
      const response = await getCriterionList();
      setCriteria(response.data);
      setModalSuccessText("¡Criterio eliminado correctamente!");
      setShowModalSuccess(true);
      setShowModalDelete(false);
    } catch (error) {
      console.error('Error deleting criterion:', error);
    }
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.description || !formData.weight || !selectedCategoryId) {
      setErrorMessage('Por favor complete todos los campos');
      setShowModalAlertWarning(true);
      return;
    }
    
    if (formData.description.length > 200) {
      setErrorMessage('La descripción no puede exceder los 200 caracteres');
      setShowModalAlertWarning(true);
      return;
    }

    const criterionData = {
      name: formData.name,
      description: formData.description,
      weight: parseInt(formData.weight),
      categoryId: parseInt(selectedCategoryId) 
    };

    try {
      if (editingId) {
        const response = await updateCriterion(editingId, criterionData);
        
        if (response && response.error) {
          setErrorMessage(response.error.message || 'Error al actualizar el criterio');
          setShowModalAlertWarning(true);
          return;
        }
        
        setModalSuccessText('¡Su criterio fue modificado con éxito!');
      } else {
        await createCriterion(criterionData);
        setModalSuccessText('¡Su criterio fue agregado con éxito!');
      }
      
      const response = await getCriterionList();
      setCriteria(response.data);
      resetForm();
      setShowModalSuccess(true);
    } catch (error) {
    let errorMsg = 'Ocurrió un error al guardar el criterio';
    
    if (error.response) {
      if (error.response.data && error.response.data.message) {
        errorMsg = error.response.data.message;
      } else if (error.response.status === 400) {
        errorMsg = 'Datos inválidos enviados al servidor';
      } else if (error.response.status === 404) {
        errorMsg = 'Criterio no encontrado';
      }
    } else if (error.request) {
      errorMsg = 'No se pudo conectar con el servidor';
    }
    
    setErrorMessage(errorMsg);
    setShowModalAlertWarning(true);
    }
  };

  const closeModalSuccess = () => {
  setShowModalSuccess(false);
  };

  const tableConfig = {
    headers: ['#', 'Criterio', 'Porcentaje', 'Descripción', 'Acciones'],
    accessors: ['id', 'name', 'weight', 'description', 'acciones'],
    widths: ['35px', '150px', '100px', '200px', '100px']
  };


  return (
    <div>
        <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300"/>
        <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
            <div className="md:pt-8 pt-4 pb-10 px-[3%] flex flex-col gap-4">
              <h1 className="text-blue font-itcmedium md:text-[32px] text-2xl">Criterios de evaluación</h1>
              <h2 className="text-[#6B7280] font-itcbook text-base md:text-2xl">Describa la evaluación de proveedores según criterio</h2>
              <div className="flex flex-col items-start justify-center gap-4 ">
                <div className="flex items-center justify-center w-full">
                  <div className="bg-[#00769633] flex  md:flex-row flex-col items-center justify-center gap-6 w-full rounded-2xl p-4">
                    <div className="flex flex-row  md:flex-col w-full md:w-[20%] justify-center gap-4 items-center md:items-start">
                      <p className="text-blue font-itcdemi text-[24px] text-left">
                        {editingId ? 'Editar criterio' : 'Agregar nuevo criterio'}
                      </p>
                      <svg width="73" height="73" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.9375 6.125C15.5231 6.125 15.1257 6.28962 14.8326 6.58265C14.5396 6.87567 14.375 7.2731 14.375 7.6875V23.0562C13.4435 22.4075 12.3735 21.9852 11.25 21.8229V7.6875C11.25 6.4443 11.7439 5.25201 12.6229 4.37294C13.502 3.49386 14.6943 3 15.9375 3H25.0646C25.6802 2.99999 26.2897 3.12124 26.8584 3.3568C27.4271 3.59237 27.9439 3.93764 28.3792 4.37292L38.0021 13.9958C38.8812 14.875 39.375 16.0667 39.375 17.3083V34.7708C39.375 36.014 38.8811 37.2063 38.0021 38.0854C37.123 38.9645 35.9307 39.4583 34.6875 39.4583H29.6979C29.3445 38.2737 28.6957 37.1983 27.8125 36.3333H34.6875C35.1019 36.3333 35.4993 36.1687 35.7924 35.8757C36.0854 35.5827 36.25 35.1852 36.25 34.7708V17.5792H29.4875C28.2443 17.5792 27.052 17.0853 26.1729 16.2062C25.2939 15.3272 24.8 14.1349 24.8 12.8917V6.125H15.9375ZM27.925 8.3375V12.8917C27.925 13.7542 28.625 14.4542 29.4875 14.4542H34.0396L27.925 8.3375ZM34.6875 44.6667H29.2958C29.7458 43.7188 29.9979 42.6604 29.9979 41.5417H34.6854C36.4812 41.5417 38.2033 40.8283 39.4731 39.5585C40.7429 38.2888 41.4562 36.5666 41.4562 34.7708V17.4521L43.2104 19.2021C44.0896 20.0833 44.5833 21.275 44.5833 22.5187V34.7708C44.5833 37.3954 43.5407 39.9124 41.6849 41.7682C39.8291 43.6241 37.312 44.6667 34.6875 44.6667ZM10.2083 34.25C11.5897 34.25 12.9144 33.7013 13.8912 32.7245C14.8679 31.7478 15.4167 30.423 15.4167 29.0417C15.4167 27.6603 14.8679 26.3356 13.8912 25.3588C12.9144 24.3821 11.5897 23.8333 10.2083 23.8333C8.827 23.8333 7.50224 24.3821 6.52549 25.3588C5.54873 26.3356 5 27.6603 5 29.0417C5 30.423 5.54873 31.7478 6.52549 32.7245C7.50224 33.7013 8.827 34.25 10.2083 34.25ZM10.2083 26.9583C10.7609 26.9583 11.2908 27.1778 11.6815 27.5685C12.0722 27.9592 12.2917 28.4891 12.2917 29.0417C12.2917 29.5942 12.0722 30.1241 11.6815 30.5148C11.2908 30.9055 10.7609 31.125 10.2083 31.125C9.6558 31.125 9.12589 30.9055 8.73519 30.5148C8.34449 30.1241 8.125 29.5942 8.125 29.0417C8.125 28.4891 8.34449 27.9592 8.73519 27.5685C9.12589 27.1778 9.6558 26.9583 10.2083 26.9583ZM22.7083 46.75C24.0897 46.75 25.4144 46.2013 26.3912 45.2245C27.3679 44.2478 27.9167 42.923 27.9167 41.5417C27.9167 40.1603 27.3679 38.8356 26.3912 37.8588C25.4144 36.8821 24.0897 36.3333 22.7083 36.3333C21.327 36.3333 20.0022 36.8821 19.0255 37.8588C18.0487 38.8356 17.5 40.1603 17.5 41.5417C17.5 42.923 18.0487 44.2478 19.0255 45.2245C20.0022 46.2013 21.327 46.75 22.7083 46.75ZM22.7083 39.4583C23.2609 39.4583 23.7908 39.6778 24.1815 40.0685C24.5722 40.4592 24.7917 40.9891 24.7917 41.5417C24.7917 42.0942 24.5722 42.6241 24.1815 43.0148C23.7908 43.4055 23.2609 43.625 22.7083 43.625C22.1558 43.625 21.6259 43.4055 21.2352 43.0148C20.8445 42.6241 20.625 42.0942 20.625 41.5417C20.625 40.9891 20.8445 40.4592 21.2352 40.0685C21.6259 39.6778 22.1558 39.4583 22.7083 39.4583ZM25.375 28.5833C25.5285 28.4403 25.6516 28.2678 25.737 28.0761C25.8224 27.8845 25.8684 27.6776 25.8721 27.4678C25.8758 27.258 25.8372 27.0496 25.7586 26.855C25.68 26.6604 25.563 26.4837 25.4147 26.3353C25.2663 26.187 25.0896 26.07 24.895 25.9914C24.7004 25.9128 24.492 25.8742 24.2822 25.8779C24.0724 25.8816 23.8655 25.9276 23.6739 26.013C23.4822 26.0984 23.3097 26.2215 23.1667 26.375L7.54167 42C7.38815 42.143 7.26502 42.3155 7.17962 42.5072C7.09422 42.6989 7.0483 42.9058 7.0446 43.1156C7.0409 43.3254 7.07949 43.5338 7.15808 43.7283C7.23666 43.9229 7.35363 44.0996 7.502 44.248C7.65038 44.3964 7.82711 44.5133 8.02167 44.5919C8.21623 44.6705 8.42462 44.7091 8.63442 44.7054C8.84422 44.7017 9.05112 44.6558 9.24279 44.5704C9.43445 44.485 9.60695 44.3618 9.75 44.2083L25.375 28.5833Z" fill="#007696"/>
                      </svg>
                    </div>          
                    
                    <div className="flex flex-col md:flex-row items-center justify-between w-full md:w-[60%] gap-3 md:gap-8">
                      <div className="flex flex-col w-full gap-3 md:w-1/2">
                        <div className="flex flex-col w-full gap-2">
                          <p className="font-itcdemi text-[#1F1F1F] lg:text-[14px]  text-[16px]">Escoja la categoría: <span className="text-red-500">*</span></p>
                          <SelectField 
                            placeholder="Escoger"
                            name="categoryId"
                            value={selectedCategoryId || ''}
                            onChange={(e) => {
                              setSelectedCategoryId(e.target.value || null);
                              setIsFormChanged(true); 
                            }}
                            options={categories.map(category => ({
                              value: category.id,
                              label: category.name
                            }))}
                          />
                        </div>

                        <div className="flex flex-col w-full gap-2">
                          <p className="font-itcdemi text-[#1F1F1F] lg:text-[14px]  text-[16px]">Especificar porcentaje: <span className="text-red-500">*</span></p>
                          <div className="border-[1px] w-full bg-white  flex rounded-[6px] border-[#D1D5DB]">
                            <input
                              type="number"
                              name="weight"
                              min="0"
                              max="100"
                              value={formData.weight}
                              onChange={handleInputChange}
                              placeholder="Describa"
                              className="rounded-l-[6px] font-itcbook w-full placeholder:text-[#6B7280] outline-none p-2 placeholder:font-itcbook placeholder:text-[14px] text-[14px]"
                            />
                            <p className="text-[#5A5A5A] p-2 border-l-[1px] text-center border-[#D1D5DB] w-[45px] lg:text-[14px]  text-[16px] font-itcdemi">%</p>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col w-full gap-3 md:w-1/2">
                        <div className="flex flex-col w-full gap-2">
                          <p className="font-itcdemi text-[#1F1F1F] lg:text-[14px]  text-[16px]">Escriba el nombre del criterio: <span className="text-red-500">*</span></p>
                          <InputField
                            onChange={handleInputChange}
                            placeholder="Describa"
                            value={formData.name}
                            name="name"
                          />
                        </div>
      
                        <div className="flex flex-col items-start w-full gap-2">
                          <p className="font-itcdemi text-[#1F1F1F] lg:text-[14px]  text-[16px]">Cómo se calcula este criterio: <span className="text-red-500">*</span></p>
                          <textarea 
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            placeholder="Describa"
                            maxLength={200}
                            className="w-full p-2 border-[1px] rounded-[6px] border-[#D1D5DB] h-[40px] lg:text-[14px]  text-[16px] placeholder:text-[#6B7280] font-itcbook placeholder:font-itcbook focus:outline-none "
                          />
                        </div>
                      </div>
                    </div>
                    
                    <div className="flex flex-row  md:flex-col justify-center items-center h-full w-full md:w-[30%] gap-6">
                      <button
                        onClick={handleSubmit}
                        disabled={ (
                          !formData.name &&
                          !formData.description && 
                          !formData.weight &&
                          !selectedCategoryId &&
                          formData.description.length > 200 )||
                          (!isFormChanged && editingId)
                        }
                        className={`text-white bg-blue rounded-lg w-[161px] h-[50px] font-itcdemi text-[18px] 
                          ${(!formData.name || 
                            !formData.description || 
                            !formData.weight ||
                            !selectedCategoryId ||
                            formData.description.length > 200 ||
                            (!isFormChanged && editingId)) ? 'bg-gray   cursor-not-allowed' : 'cursor-pointer'}`}
                      >   
                        Guardar
                      </button>  
                      <button
                        onClick={resetForm}
                        disabled={isFormEmpty}
                        className={`text-blue w-[161px] h-[50px] font-itcdemi rounded-lg text-[18px] border-[2px] border-blue
                          ${isFormEmpty ? 'border-gray text-gray cursor-not-allowed' : 'cursor-pointer'}`}
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  {isLoading ? (
                    <div>Cargando datos...</div>
                  ) : (
                    <div className="w-full">
                      <CategoryTabs 
                        categories={criteria} 
                        activeTab={activeCategoryTab}
                        onTabChange={setActiveCategoryTab}
                      />
                    <div className="w-full mt-4 overflow-hidden overflow-x-auto">
                      <DynamicTable
                        data={criteria[activeCategoryTab]?.criteria?.map((item, index) => ({
                          ...item,
                          id: index + 1,
                          originalId: item.id,
                          categoryId: item.categoryId || criteria[activeCategoryTab]?.id,
                          weight: `${item.weight}%`,
                          acciones: { 
                            editar: () => handleEdit({
                              ...item,
                              categoryId: item.categoryId || criteria[activeCategoryTab]?.id
                            }),
                            eliminar: () => handleDelete(item.id)
                          }
                        })) || []}
                        config={tableConfig}
                        showRadioButtons={false}
                        showPagination={false}
                        collapsed={false}
                      />
                    </div>
                    </div>
                  )}
                </div>

              </div>
            </div>
        </div>

      <ModalDelete 
        showModalDelete={showModalDelete}
        closeModal={() => setShowModalDelete(false)}
        accept={handleConfirmDelete}
        textType="criterio"
      />

      <ModalSuccess 
        showModalSuccess={showModalSuccess}
        closeModalSuccess={closeModalSuccess}
        fill="green"
        text={modalSuccessText}
      />

      <ModalAlertWarning 
        showModalAlertWarning={showModalAlertWarning}
        closeModal={() => setShowModalAlertWarning(false)}
        error={errorMessage}
        accept={() => setShowModalAlertWarning(false)}
      />
    </div>
  );
}